export default {
  default: () => import("/tmp/build/38bfee86/code/layouts/default.vue").then(m => m.default || m)
}